import React from 'react';
import './Card.css';

function Card({ 
  children, 
  className = '',
  hoverable = true,
  onClick
}) {
  return (
    <div 
      className={`card ${hoverable ? 'card-hoverable' : ''} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
}

export default Card;








